var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-space-between":"","row":"","fill-height":""}},[_c('v-flex',[_c('h1',[_vm._v(" Your request has been completed. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }